import { styled } from '@mui/material/styles';
import { Box, Button, Container, Divider, Typography } from '@mui/material';
import useAuth from '../../../hooks/useAuth';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Link } from "react-router-dom";
import { BASE_PATH } from '../../../config'

const RootStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: theme.palette.grey[500_12],
    transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shorter,
    }),
}));

// ----------------------------------------------------------------------

type Props = {
    isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
    const { user } = useAuth();

    return (
        <RootStyle
            sx={{
                ...(isCollapse && {
                    bgcolor: 'transparent',
                }),
            }}
        >

            <Box
                sx={{
                    ml: 2,
                    transition: (theme) =>
                        theme.transitions.create('width', {
                            duration: theme.transitions.duration.shorter,
                        }),
                    ...(isCollapse && {
                        ml: 0,
                        width: 0,
                    }),
                }}
            >
                <Typography variant="subtitle2" noWrap>
                    {user?.fullname}
                </Typography>
                <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
                    {user?.profilename} <br/> {user?.companycode}
                </Typography>

                <Divider sx={{ margin: 1 }}/>

                <Container>
                    <Button
                        component={Link}
                        to={BASE_PATH + "/logout"}
                        variant="contained"
                        endIcon={
                            <FontAwesomeIcon icon={"fa-solid fa-unlock" as IconProp}/>}>Logout</Button>
                </Container>
            </Box>
        </RootStyle>
    );
}
